export default "__VITE_ASSET__DYuBbpHu__"